<template>
<div>
  <span class="strip"></span>
  <VueDocPreview :value="selected_file.docValue" :type="selected_file.docType" />
  </div>
</template>

<script>
import VueDocPreview from 'vue-doc-preview'
export default {
components: {
    VueDocPreview
  },
  props:[
    'selected_file'
  ],
  data: () => ({
      //docValue:"https://volptestbucket.s3.ap-south-1.amazonaws.com/TestOnly/quiz.xlsx",
      //docValue:"https://volptestbucket.s3.ap-south-1.amazonaws.com/TestOnly/sample.pptx",
      //docValue:"https://volptestbucket.s3.ap-south-1.amazonaws.com/TestOnly/ticket.pdf",
      //docValue:"https://volptestbucket.s3.ap-south-1.amazonaws.com/TestOnly/AL.docx",
      //docType:'office',
      //docType:'text',
  }),
  mounted(){

  }
}
</script>

<style>
    .strip{
       background: #fff;
    padding: 2.8rem 213rem;
    margin-top: 0rem;
    margin-left: -16rem;
    position: absolute;}
</style>